import * as R from "ramda";
import { Component } from "react";
import FlexView from "react-flexview";
import SimpleButton from "../../../../../modules/commons/SimpleButton";
import SimpleDataTable from "../../../../../modules/SimpleDataTable";
import SimpleDDL from "../../../../../modules/SimpleDDL";
import Api from "../../../../../Services/Api";
import { fetchDataAsync } from "../../../../../Services/Utils";
import { HttpStatus } from "../../../../common/Constants";
import { configMonthToDate, monthOptions, transformResponseMTD, yearOptions } from "../config";
import React from "react";
import moment from "moment";

class MonthToDateSales extends Component {
  constructor(props) {
    super(props);
    this.state = {
      month: null,
      year: null,
      tableConfig: [],
      dataTable1: [],
      dataTable2: [],
    };
  }

  componentDidMount() {
    // let currentDate = new Date();
    const currentMonth = Number(moment().format("MM"));
    const currentYear = Number(moment().format("YYYY"));

    this.setState((prevValue) => ({
      ...prevValue,
      month: monthOptions.find((item) => item.value === currentMonth),
      year: yearOptions.find(
        (item) => item.value === currentYear
      ),
      tableConfig: configMonthToDate,
    }));
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (!R.equals(JSON.stringify(prevProps.search), JSON.stringify(this.props.search))) {
      this.handleSearch();
    }
  }

  handleChangeSearchValue = (name, value) => {
    this.setState((prevValue) => ({
      ...prevValue,
      [name]: value,
    }));
  };

  fetchData = async (isMergeLeasing) => {
    try {
      this.props.triggerLoading();
      const res = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_REPORT_DTO").getLaporanPenjualanMTD,
        setError: this.props.setError,
        menuName: "Dashboard Level Team Leader - Laporan Penjualan Bulanan",
        args: {
          kodeCabang: [this.props.search.selectedCabang],
          month: this.state.month?.value,
          year: this.state.year?.value,
          employeeIdSales: this.props.search.selectedSales,
          mergerLeasing: isMergeLeasing,
          employeeIdTeamLeader: this.props.idLeader
        },
      });
      if (res.ok && res.data.status === HttpStatus.SUCCESS) {
        if (!isMergeLeasing) {
          this.setState((prevValue) => ({
            ...prevValue,
            dataTable1: transformResponseMTD(res.data.data),
          }));
        } else {
          this.setState((prevValue) => ({
            ...prevValue,
            dataTable2: transformResponseMTD(res.data.data),
          }));
        }
      }
      this.props.triggerLoading();
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  handleSearch = () => {
    this.fetchData();
    this.fetchData(true)
  }

  render() {
    return (
      <>
        <FlexView style={{ gap: "20px", alignItems: "center" }}>
          <SimpleDDL
            id="select_options_month"
            box="search"
            name="month"
            containerclassname="width width-250px"
            placeholder="Bulan"
            menuPosition="fixed"
            isClearable
            options={monthOptions}
            value={this.state.month}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleDDL
            id="select_options_year"
            box="search"
            name="year"
            containerclassname="width width-250px"
            placeholder="Tahun"
            menuPosition="fixed"
            isClearable
            options={yearOptions}
            value={this.state.year}
            onChange={(value, { name }) =>
              this.handleChangeSearchValue(name, value)
            }
          />
          <SimpleButton
            styles={{ marginBottom: "15px" }}
            onClick={() => this.handleSearch()}
          >
            Cari
          </SimpleButton>
        </FlexView>
        <FlexView style={{ gap: "50px" }}>
          <SimpleDataTable
            data={this.state.dataTable1}
            columns={this.state.tableConfig}
          />
          <SimpleDataTable
            data={this.state.dataTable2}
            columns={this.state.tableConfig}
          />
        </FlexView>
      </>
    );
  }
}

export default MonthToDateSales;